import { Paper, makeStyles, Typography, Button } from "@material-ui/core";
import { Warning } from "@material-ui/icons";

const useStyles = makeStyles((theme) => ({
  container: {
    display: "flex",
    borderWidth: 1,
    borderColor: theme.palette.grey[400],
    borderStyle: "dashed",
    borderRadius: 3,
    paddingTop: 30,
    paddingBottom: 30,
    paddingLeft: 20,
    paddingRight: 10,
    minHeight: 120,
  },
  icon: {
    fontSize: "3rem",
    marginRight: 30,
  },
  content: {
    flexGrow: 1,
  },
  action: {
    alignSelf: "flex-end",
  },
}));

type NoticeProps = {
  onClick: () => void;
};

export const Notice: React.FC<NoticeProps> = ({ onClick }) => {
  const classes = useStyles();
  return (
    <Paper className={classes.container}>
      <Warning className={classes.icon} color="primary" />
      <div className={classes.content}>
        <Typography variant="body1">
          <b>Information Notice (B4)</b>
          <br />
          Missing Action - Read attached document(s)
        </Typography>
      </div>
      <div className={classes.action}>
        <Button color="primary" onClick={onClick} data-test="b4-create-action">
          Create this action
        </Button>
      </div>
    </Paper>
  );
};
